import axios from 'axios';
import * as actions from './index';

const { REACT_APP_IDM_DEV_URL, REACT_APP_IDM_UAT_URL, REACT_APP_IDM_PROD_URL } = process.env;

const IDM_ENV = process.env.REACT_APP_IDM_ENV;

let IDM_BASE_URL = REACT_APP_IDM_DEV_URL;
if (IDM_ENV !== undefined && IDM_ENV === 'uat') {
    IDM_BASE_URL = REACT_APP_IDM_UAT_URL;
}

if (IDM_ENV !== undefined && IDM_ENV === 'prod') {
  IDM_BASE_URL = REACT_APP_IDM_PROD_URL
}



let axiosInstance = axios.create ({
  baseURL: IDM_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


axiosInstance.interceptors.request.use (
  function (config) {
    let userObjStr = localStorage.getItem ('myElthSessionUser');
    let userObj = undefined;
    if (userObjStr) {
      userObj = JSON.parse (userObjStr);
    }
    let token = undefined;
    if (userObj) {
      token = userObj.token;
    }
    config.headers.common['Authorization'] = `Bearer ${token}`;

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject (error);
  }
);

axiosInstance.interceptors.response.use (
  response => {
    const {status} = response;
    if ( status === 302) {
      console.log("Redirect Status on action");
    } else {
      console.log(`Status: ${status}`);
    }
    return response;
  },
  error => {
    const {response} = error;
    const {status, data} = response;
    if (
      status === 401 &&
      data.message.toLowerCase () ===
        'authentication token is invalid or expired.  please login again.'
    ) {
      localStorage.removeItem ('myElthSessionUser');
      actions.logout ();
    }
    return Promise.reject (error);
  }
);

// Alter defaults after instance has been created
//axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;

export default axiosInstance;
